export default __webpack_public_path__ + "static/media/arrow-brand.fbfaa5ee.svg";